var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNetwork = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "95gi40tmma",
    d: "M0.641 0.195L6.933 0.195 6.933 6.49 0.641 6.49z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(0 .75)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .75) translate(8 6.667) translate(21.333 .472)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "oe8wddym8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#95gi40tmma"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EFB726",
    d: "M6.933 3.341c0 1.738-1.407 3.149-3.145 3.149C2.052 6.49.64 5.08.64 3.34c0-1.738 1.41-3.146 3.147-3.146 1.738 0 3.145 1.408 3.145 3.146",
    mask: "url(#oe8wddym8b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M7.07 32.203l2.201-6.796c.008 0 .014.004.02.004h13.326l2.246 6.792H7.071zm8.803-27.176l2.994 9.051H12.94l2.932-9.051zm-3.663 11.31h7.405l2.25 6.803h-11.86l2.205-6.803zm18.403 15.866h-3.347L18.033 4.305c-.311-.929-1.181-1.554-2.162-1.554-.978.002-1.847.63-2.156 1.56L4.67 32.202H1.139c-.63 0-1.138.51-1.138 1.134 0 .628.508 1.134 1.138 1.134H30.613c.629 0 1.138-.506 1.138-1.134 0-.624-.51-1.134-1.138-1.134z",
    transform: "translate(0 .75) translate(8 6.667)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNetwork);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_network.aee0f458123a71c49d1bb8bf4f4c3664.svg";